<template>
    <div class="home__quote-one">
        <div class="step">
            <h5 class="step-title">
                {{ $t("promo.1 How much do you pay for electricity?") }}
                
                <div style="width: 14px">
                    <info-tooltip
                        :text="$t('promo.Tooltips - step 1 - consumption')"
                    />
                </div>
            </h5>
            <div class="input-wrapper" :class="{ error: error }">
                <label class="decor" for="mainInput">
                    <img src="/images/promo/input_decor.svg" alt="" />
                </label>
                <input
                    v-if="locale === 'pl'"
                    id="mainInput"
                    class="shadow-none"
                    type="tel"
                    v-model.number="paying_monthly"
                    :placeholder="$t('promo.Input placeholder')"
                /><input
                    v-else
                    id="mainInput"
                    class="shadow-none"
                    type="tel"
                    v-model.number="annual_consumption"
                    :placeholder="$t('promo.Input placeholder')"
                />
                <span class="value">{{ $t("promo.EUR/month") }}</span>
            </div>
            <h5 class="step-title">
                {{ $t("promo.2 Select your roof type below") }}
                
                <div style="width: 14px">
                    <info-tooltip :text="$t('promo.Tooltips - step 1 - roof')" />
                </div>
            </h5>
            <div
                class="roof-select d-block d-md-none"
                :style="{
                    backgroundImage: 'url(/images/promo/chevron-down.svg)',
                }"
            >
                <select name="" id="" v-model="roof_type">
                    <option selected value="Tiles" disabled>
                        {{ $t("promo.Select an option") }}
                    </option>
                    <option v-for="o in roofs_data" :key="o.id" :value="o.id">
                        {{ o.name }}
                    </option>
                </select>
            </div>

            <div class="roof-options d-none d-md-flex">
                <div
                    class="roof-tile"
                    v-for="roofType in roofs_data"
                    :key="`roof-tile-${roofType}`"
                    :class="{ active: roof_type === roofType.id }"
                    @click="roof_type = roofType.id"
                >
                    <input
                        type="radio"
                        name="roof"
                        :id="`roof-${roofType.id}`"
                        :value="roofType.id"
                        v-model="roof_type"
                    />
                    <label for="roof-tiles">
                        <div>
                            <img
                                :srcset="`${roofType.img2x} 2x`"
                                :src="roofType.img1x"
                                width="120"
                                height="120"
                                alt="roof tile"
                            />
                        </div>
                        <span class="text">
                            {{ roofType.name }}
                            <span class="radio-ui"></span>
                        </span>
                    </label>
                </div>
            </div>
            <div class="step-cta">
                <button
                    class="btn btn-primary"
                    id="get-price"
                    @click="nextStep"
                >
                    {{ $t("promo.Get my price") }}
                    <img src="/images/promo/arrow-right.svg" alt="" />
                </button>
                <div class="tip text-center">
                    {{ $t("promo.Go to next page to customise your quote") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoTooltip from "./InfoTooltip";

export default {
    components: { InfoTooltip },
    data() {
        return {
            paying_monthly: null,
            annual_consumption: null,
            roof_type: "Tiles",
            roof_options: ["Tiles", "Metal", "Stone", "Flat"],
            error: false,
        };
    },
    computed: {
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
        roofs_data() {
            let common = [
                {
                    id: "Tiles",
                    name: this.$t("promo.Tiles"),
                    img1x: "/images/promo/roof/tile1x.jpg",
                    img2x: "/images/promo/roof/tile2x.jpg",
                },
                {
                    id: "Metal",
                    name: this.$t("promo.Metal"),
                    img1x: "/images/promo/roof/metal1x.jpg",
                    img2x: "/images/promo/roof/metal2x.jpg",
                },
            ];
            let nl = [
                {
                    id: "Stone",
                    name: this.$t("promo.Stone"),
                    img1x: "/images/promo/roof/stone1x.jpg",
                    img2x: "/images/promo/roof/stone2x.jpg",
                },
                {
                    id: "Flat",
                    name: this.$t("promo.Flat"),
                    img1x: "/images/promo/roof/flat1x.jpg",
                    img2x: "/images/promo/roof/flat2x.jpg",
                },
            ];
            let pl = [
                {
                    id: "Flat",
                    name: this.$t("promo.Flat"),
                    img1x: "/images/promo/roof/flat-pl.jpg",
                    img2x: "/images/promo/roof/flat-pl@2x.jpg",
                },
                {
                    id: "Ground",
                    name: this.$t("promo.Ground"),
                    img1x: "/images/promo/roof/ground-pl.jpg",
                    img2x: "/images/promo/roof/ground-pl@2x.jpg",
                },
            ];
            if (this.locale === "nl") {
                return [...common, ...nl];
            } else {
                return [...common, ...pl];
            }
        },

        ...mapGetters({
            monthly_payment: "monthly_payment",
            roof: "roof_type",
        }),
    },
    watch: {
        annual_consumption: {
            handler() {
                this.error = false;
                this.$store.dispatch(
                    "setAnnualConsumption",
                    this.annual_consumption
                );
                this.$store.dispatch(
                    "setMonthlyPayment",
                    (this.annual_consumption * 0.27) / 12
                );
                this.$store.dispatch("setOptions", {
                    panel_type: "glass-foil",
                });
            },
        },
        paying_monthly: {
            handler() {
                this.error = false;
                this.$store.dispatch(
                    "setAnnualConsumption",
                    (this.paying_monthly / 0.55) * 12
                );
                this.$store.dispatch("setMonthlyPayment", this.paying_monthly);
                this.$store.dispatch("setOptions", {
                    panel_type: "glass-foil",
                });
            },
        },
    },
    methods: {
        nextStep() {
            if (!this.paying_monthly && !this.annual_consumption) {
                this.error = true;
            } else {
                this.$store.dispatch("setRoofType", this.roof_type).then(() => {
                    this.$inertia.get(this.route("promo-quote"));
                });
            }
        },
    },
    mounted() {
        if (this.roof) {
            this.roof_type = this.roof;
        }
        if (this.monthly_payment) {
            this.paying_monthly = this.monthly_payment;
        }
    },
};
</script>

<style lang="scss" scoped>
.home__quote-one {
    .step-title {
        font-style: normal;
        font-weight: 600;
        font-size: 16px !important;
        line-height: 28px;
        color: #141430;
    }

    .roof-select {
        background-color: #ffffff;
        border: 1px solid #d8d8d8;
        border-radius: 6px;
        height: 50px;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
        background-repeat: no-repeat;
        background-position-x: calc(100% - 30px);
        background-position-y: center;

        select {
            height: 50px;
            display: block;
            width: 120%;
            padding: 0px 38px;
            padding-right: calc(20% + 30px);
            border: none;
            background: transparent;
            appearance: none;
            outline: none !important;
        }
    }
    @keyframes decorAnimation {
        0% {
            left: 0;
        }
        50% {
            left: -10px;
        }
        100% {
            left: 0;
        }
    }

    .input-wrapper {
        height: 50px;
        background: #ffffff;
        box-sizing: border-box;
        border-radius: 50px;
        display: inline-flex;
        align-items: center;
        padding: 0 0 0 10px;
        width: 290px;
        position: relative;
        margin-bottom: 28px;
        border: 2px solid #2775f9;
        .decor {
            display: block;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%) translateX(-8px);
            animation: decorAnimation;
            animation-duration: 1s;
            animation-iteration-count: 4;
        }
        &.error {
            border-color: #f00;
            animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        }

        @media (max-width: 1024px) {
            width: auto;
        }

        input {
            height: 48px;
            border: none;
            outline: none;
            width: auto;
            display: block;
            max-width: 100%;
            width: 100%;
            min-width: 100%;
            padding: 0px 32px;
            padding-right: 120px;
            position: relative;
            z-index: 4;
            background: transparent;
            font-weight: 600;
            font-size: 16px;
            color: #2c2c4f;

            &::placeholder {
                color: rgba(20, 20, 48, 0.5);
            }
        }

        .value {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 28px;
            color: #959bb5;
            position: absolute;
            right: 0;
            padding-right: 18px;
            z-index: 2;
        }
    }

    .roof-options {
        margin-bottom: 30px;
    }

    .roof-tile {
        background: #ffffff;
        border: 1px solid #d8d8d8;
        border-radius: 6px;
        flex: 1;
        transition: 0.3s;
        margin-right: 14px;

        &.active {
            border: 1px solid #2876f9;
            box-shadow: inset 0px 0px 0px 1px #2775f9;
            transition: 0.3s;

            .radio-ui {
                border-color: #2775f9;
                box-shadow: inset 0px 0px 0px 3px #2775f9;
                transition: 0.3s;
            }
        }

        input {
            display: none;
        }

        label {
            padding: 8px;
            display: block;
            margin: 0;
            cursor: pointer;

            .text {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 8px;
            }

            .radio-ui {
                width: 18px;
                height: 18px;
                min-width: 18px;
                border: 1px solid #dadce6;
                border-radius: 50%;
                display: inline-block;
                transition: 0.3s;
            }
        }
    }

    .step-cta {
        width: 290px;
        @media (max-width: 1024px) {
            width: auto;
        }

        .btn {
            background: #1eb26d;
            border-radius: 50px;
            height: 56px;
            width: 100%;
            border: none;
            outline: none !important;
            font-weight: 600;
            font-size: 18px;
            color: #ffffff;
            margin-bottom: 8px;
            box-shadow: none !important;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                margin-left: 10px;
            }

            &:hover,
            &:active {
                background: darken(#1eb26d, 5%);
            }
        }

        .tip {
            font-weight: normal;
            font-size: 14px;
            color: #959bb5;
        }
    }
}

@keyframes shake {
    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}
</style>
